import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appUIReducer from 'features/appUI/slice';
import authReducer from 'features/auth/slice';
import hotelReducer from 'features/hotel/slice';
import { baseApi } from 'lib/rtkQuery/baseApi';

export const store = configureStore({
  reducer: {
    baseApi: baseApi.reducer,
    ui: appUIReducer,
    auth: authReducer,
    hotel: hotelReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['scanner.onScan', 'modals'],
        ignoredActionPaths: [
          'payload.onScan',
          'payload.element',
          'meta.arg.originalArgs',
        ],
        warnAfter: 128,
      },
      immutableCheck: {
        warnAfter: 128,
      },
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
